/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_GrantAcceptanceTemplate_AwardForAgreementPreviewDto } from '../models/Wealthlane_AwardService_Dtos_GrantAcceptanceTemplate_AwardForAgreementPreviewDto';
import type { Wealthlane_AwardService_Dtos_GrantAcceptanceTemplate_PreviewGrantAcceptanceTemplateDto } from '../models/Wealthlane_AwardService_Dtos_GrantAcceptanceTemplate_PreviewGrantAcceptanceTemplateDto';
import type { Wealthlane_AwardService_Dtos_GrantAcceptanceTemplate_RenderGrantAcceptanceTemplateDto } from '../models/Wealthlane_AwardService_Dtos_GrantAcceptanceTemplate_RenderGrantAcceptanceTemplateDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class GrantAcceptanceTemplateForViewService {

    /**
     * @returns Wealthlane_AwardService_Dtos_GrantAcceptanceTemplate_AwardForAgreementPreviewDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppGrantAcceptanceTemplateForViewRsuAwardsForAgreementPreview(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_GrantAcceptanceTemplate_AwardForAgreementPreviewDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/grant-acceptance-template-for-view/rsu-awards-for-agreement-preview',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_GrantAcceptanceTemplate_AwardForAgreementPreviewDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppGrantAcceptanceTemplateForViewPsuAwardsForAgreementPreview(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_GrantAcceptanceTemplate_AwardForAgreementPreviewDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/grant-acceptance-template-for-view/psu-awards-for-agreement-preview',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_GrantAcceptanceTemplate_AwardForAgreementPreviewDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppGrantAcceptanceTemplateForViewOptionAwardsForAgreementPreview(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_GrantAcceptanceTemplate_AwardForAgreementPreviewDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/grant-acceptance-template-for-view/option-awards-for-agreement-preview',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns string OK
     * @throws ApiError
     */
    public static postApiAwardApiAppGrantAcceptanceTemplateForViewPreviewGrantAcceptanceTemplate(
requestBody?: Wealthlane_AwardService_Dtos_GrantAcceptanceTemplate_PreviewGrantAcceptanceTemplateDto,
): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/grant-acceptance-template-for-view/preview-grant-acceptance-template',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns string OK
     * @throws ApiError
     */
    public static postApiAwardApiAppGrantAcceptanceTemplateForViewRenderGrantAcceptanceTemplate(
requestBody?: Wealthlane_AwardService_Dtos_GrantAcceptanceTemplate_RenderGrantAcceptanceTemplateDto,
): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/grant-acceptance-template-for-view/render-grant-acceptance-template',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param rsuAwardId 
     * @returns string OK
     * @throws ApiError
     */
    public static getApiAwardApiAppGrantAcceptanceTemplateForViewGrantAcceptanceTemplateForRsuAwardId(
rsuAwardId: string,
): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/grant-acceptance-template-for-view/grant-acceptance-template-for-rsu-award-id/{rsuAwardId}',
            path: {
                'rsuAwardId': rsuAwardId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param psuAwardId 
     * @returns string OK
     * @throws ApiError
     */
    public static getApiAwardApiAppGrantAcceptanceTemplateForViewGrantAcceptanceTemplateForPsuAwardId(
psuAwardId: string,
): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/grant-acceptance-template-for-view/grant-acceptance-template-for-psu-award-id/{psuAwardId}',
            path: {
                'psuAwardId': psuAwardId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param optionAwardId 
     * @returns string OK
     * @throws ApiError
     */
    public static getApiAwardApiAppGrantAcceptanceTemplateForViewGrantAcceptanceTemplateForOptionAwardId(
optionAwardId: string,
): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/grant-acceptance-template-for-view/grant-acceptance-template-for-option-award-id/{optionAwardId}',
            path: {
                'optionAwardId': optionAwardId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param warrantId 
     * @returns string OK
     * @throws ApiError
     */
    public static getApiAwardApiAppGrantAcceptanceTemplateForViewGrantAcceptanceTemplateForWarrantId(
warrantId: string,
): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/grant-acceptance-template-for-view/grant-acceptance-template-for-warrant-id/{warrantId}',
            path: {
                'warrantId': warrantId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
